import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  FaShoppingCart,
  FaCogs,
  FaTruck,
  FaMoneyCheckAlt,
  FaCheckCircle,
} from "react-icons/fa";
import { MdFlight } from "react-icons/md";
import { GiFullMotorcycleHelmet } from "react-icons/gi";
import "./Orderid.css";
import { RxCrossCircled } from "react-icons/rx";

function Orderid({ orders }) {
  const { orderid } = useParams();         // might be "T35121"
  const location = useLocation();
  const [order, setOrder] = useState(location.state?.order || null);

  useEffect(() => {
    if (!order && orders && orders.length > 0) {
      // compare stripping # too
      const found = orders.find(item =>
        item.tracking_number.replace(/^#/, "") === (orderid || "").replace(/^#/, "")
      );
      if (found) setOrder(found);
    }
  }, [orderid, orders, order]);

  console.log("orderid", orderid);
  console.log("location.state", location.state);
  console.log("order from state or fallback", order);

  
  if (!order) {
    return <p>❌ Order not found or missing data.</p>;
  }
  // Progress tracker config
  let steps = [
    { label: "Order Created", icon: <FaShoppingCart /> },
    { label: "In Progress", icon: <FaCogs /> },
  ];

  // Append based on order_status
  if (order?.order_status === "Cancelled") {
    steps.push({ label: "Cancelled", icon: <FaCheckCircle /> });
  } else if (order?.order_status === "Exchange") {
    steps.push({ label: "Exchanged", icon: <FaCheckCircle /> });
  } else {
    steps = [
      ...steps,
      { label: "Shipment", icon: <FaTruck /> },
      { label: "Payment", icon: <FaMoneyCheckAlt /> },
      { label: "Delivered", icon: <FaCheckCircle /> },
    ];
  }

  const statusStepMap = {
    "Order Created": 0,
    "In Progress": 1,
    Shipment: 2,
    Payment: 3,
    Delivered: 4,
    Cancelled: 2,
    Exchange: 2,
  };

  const currentStep = statusStepMap[order?.order_status] ?? 0;
  const isSpecialStop =
    order?.order_status === "Cancelled" || order?.order_status === "Exchange";

  return (
    <>
      <h1 className="dashboard-heading">Order ID: {order.tracking_number}</h1>

      {/* Progress Tracker */}
      <div className="progress-tracker-box">
        <div className="progress-tracker">
          {steps.map(({ label, icon }, index) => {
            const isCompleted = index < currentStep;
            const isActive = index === currentStep;

            const isCancelledStep =
              isSpecialStop && index === currentStep && label === "Cancelled";
            const isExchangeStep =
              isSpecialStop && index === currentStep && label === "Exchanged";

            return (
              <div key={index} className="step-container">
                <div
                  className={`step-circle ${
                    isCancelledStep || isExchangeStep
                      ? "special-step" // red
                      : isCompleted
                      ? "completed"
                      : isActive
                      ? "active"
                      : ""
                  }`}
                >
                  {isCancelledStep || isExchangeStep ? (
                    <RxCrossCircled className="check-icon" />
                  ) : isCompleted ? (
                    <FaCheckCircle className="check-icon" />
                  ) : (
                    icon
                  )}
                </div>
                <div
                  className={`step-label ${
                    isCancelledStep || isExchangeStep ? "special-label" : ""
                  }`}
                >
                  {label}
                </div>

                {index !== steps.length - 1 && (
                  <div
                    className={`step-line ${
                      isCompleted
                        ? "completed"
                        : isCancelledStep || isExchangeStep
                        ? "special-line"
                        : ""
                    }`}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="order-box">
        <div className="order-box-flex">
          {/* Left Box */}
          <div className="order-box-left">
            <h3 className="section-title">Customer Details</h3>
            <div className="detail-row">
              <span className="label">Name:</span>
              <span className="value">{order?.customer_name}</span>
            </div>
            <div className="detail-row">
              <span className="label">Phone:</span>
              <span className="value">{order?.phone}</span>
            </div>
            <div className="detail-row">
              <span className="label">Email:</span>
              <span className="value">{order?.email}</span>
            </div>
            <div className="detail-row">
              <span className="label">Order Date:</span>
              <span className="value">{order?.order_date}</span>
            </div>
            <div className="detail-row">
              <span className="label">Address:</span>
              <span className="value">{order?.ship_add}</span>
            </div>
            <div className="detail-row">
              <span className="label">Payment Status:</span>
              <span
                className={`${
                  order?.payment_status === "paid"
                    ? "value paid"
                    : "value pending"
                }`}
              >
                {order?.payment_status}
              </span>
            </div>
          </div>

          {/* Right Box */}
          <div className="order-box-right">
            <div className="order-box-top">
              <div className="order-card">
                <div className="order-card-header">
                  <GiFullMotorcycleHelmet className="order-icon" />
                  <h4 className="order-title">Delivery Boy</h4>
                </div>
                <p className="order-text">Ravi Kumar</p>
                <p className="order-text">+91 9123456780</p>
              </div>

              <div className="order-card">
                <div className="order-card-header">
                  <MdFlight className="order-icon" />
                  <h4 className="order-title">2-3 Days</h4>
                </div>
                <p className="order-text">Estimate Time</p>
              </div>
            </div>

            <div className="order-box-bottom">
              <table className="order-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Size</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{order.prod_name}</td>
                    <td>{order.size || "-"}</td>
                    <td>₹{order.amount}</td>
                    <td>{order.quantity}</td>
                    <td>₹{order.amount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Orderid;
